export default {
    projects: 'Projekte',
    project: 'Projekt',
    countProjects: '{count} Projekte|{count} Projekt|{count} Projekte',

    addLocation: '{location} hinzufügen',
    deleteLocation: '{location} löschen',
    deleteLocationText: 'Möchten Sie den Eintrag wirklich löschen?',
    locationAlreadyExists: '{location} existiert bereits',

    addProject: 'Projekt hinzufügen',
    deleteProject: 'Projekt löschen',
    deleteProjectText: 'Möchten Sie das Projekt wirklich löschen?',

    showListing: 'Liste anzeigen',
    hideListing: 'Liste verbergen',
}